import { Typography } from '@/ui-kit';
import styles from './profile-active-section.module.scss';
import { useEffect, useState } from 'react';
import { useAuth } from '@/store/useAuth';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { useToast } from '@/store/useToast';
import { ActivatedProfileIcon, ActivateProfileIcon, DeactivatedProfileIcon, DeactivateProfileIcon, ErrorNotificationIcon } from '@/assets/icons';
import { profilesApi } from '@/api';
// @ts-ignore
import Switch from 'react-ios-switch';

export const ProfileActiveSection = () => {
    const userData =
        useAuth((state) => state.getUser());    

    const { setProfile } = useAuth((state) => state);

    const [isProfileHidden, setProfileHidden] =
        useState<boolean>(!(userData?.active ?? true));

    useEffect(() => {
        setProfileHidden(
            !(
                userData?.active ?? true
            )
        );
    }, [userData])

    const showToast =
        useToast((state) => state.show);

    const handleSwitchChange = async (checked: boolean) => {
        try {
            setProfileHidden(checked);
            callYaMetrika(checked ? 'deactivate_account' : 'return_to_search');

            await profilesApi[checked ? 'deactivate' : 'activate']();
            showToast({
                icon: checked ? <DeactivateProfileIcon /> : <ActivateProfileIcon />,
                msg: checked ? 'Ваш профиль скрыт' : 'Вы снова в поиске!',
            });
            setProfile({
                ...userData,
                active: !checked,
            });
        } catch {
            showToast({
                icon: <ErrorNotificationIcon />,
                msg: 'Ошибка. Попробуйте ещё раз'
            });
            setProfileHidden(!checked);
        }
    };

    return (
        <div className={styles.hideProfileCard}>
            <div className={styles.hideProfileCardIcon}>
                {
                    isProfileHidden ?
                        <DeactivatedProfileIcon />
                    :
                        <ActivatedProfileIcon />
                }
            </div>
            <div className={styles.hideProfileCardMain}>
                <Typography
                    variant="span"
                    fontWeight="normal"
                    className={styles.hideProfileCardMainTitle}>
                    Скрыть профиль
                </Typography>
                <Typography
                    variant="span"
                    fontWeight="normal"
                    typeColor="gray-label"
                    className={styles.hideProfileCardMainSubtitle}>
                    Твой профиль не будет показываться в ленте, но текущие чаты сохранятся.
                </Typography>
            </div>
            <Switch
                checked={isProfileHidden}
                handleColor="#fff"
                offColor="#E5E5EA"
                onColor="#F26A1C"
                style={{
                    minWidth: '50px'
                }}
                onChange={handleSwitchChange} />
        </div>
    )
}
